import { createSelector, createFeatureSelector } from '@ngrx/store';
import { NavigationState } from './navigation.state';

export const selectNavigationState =
  createFeatureSelector<NavigationState>('navigation');

export const selectNadajPrzesylkeTyp = createSelector(
  selectNavigationState,
  (state: NavigationState) => state.nadajPrzesylkeTyp
);

export const selectCurrentScreen = createSelector(
  selectNavigationState,
  (state: NavigationState) => state.screen
);

export const selectSposobNadaniaTyp = createSelector(
  selectNavigationState,
  (state: NavigationState) => state.sposobNadaniaTyp
);

export const selectSposobDoreczeniaTyp = createSelector(
  selectNavigationState,
  (state: NavigationState) => state.sposobDoreczeniaTyp
);

export const selectSposobNadaniaStepNumber = createSelector(
  selectNavigationState,
  (state: NavigationState) => state.sposobNadaniaStepNumber
);
